import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_sidebarLayout/")({
  loader: () => {
    throw redirect({ to: "/lists" });
  },
});
